import { useMemo } from 'react';
import React from 'react';
const isNotNull = (value) => value !== null;
export const ProductAttributes = ({ attributes }) => {
    const variantAttributes = (attributes.used_attributes || []).filter(isNotNull);
    const variantValues = useMemo(() => {
        if (typeof attributes.attributeValues !== 'string') {
            return {};
        }
        try {
            return JSON.parse(attributes.attributeValues);
        }
        catch {
            return {};
        }
    }, [attributes.attributeValues]);
    return (React.createElement("div", { className: "flex gap-[10px] items-center" },
        variantAttributes
            .filter((attributeKey) => attributeKey === 'dosage')
            .map((attributeKey, index) => {
            const value = variantValues[attributeKey] ?? null;
            return value != null ? (React.createElement("div", { key: `${attributes.urlKey}-${attributeKey}-${index + 1}`, className: "text-xs leading-none font-gotham px-[14px] py-2 border border-brand-rule-grey rounded-md ml-0.5 text-black" },
                React.createElement("p", null, value))) : null;
        }),
        variantAttributes
            .filter((attributeKey) => attributeKey === 'flavor_size' || attributeKey === 'flavor')
            .map((attributeKey, index) => {
            const value = variantValues[attributeKey] ?? null;
            return value != null ? (React.createElement("p", { key: `${attributes.urlKey}-${attributeKey}-${index + 1}`, className: "text-xs leading-none font-gotham px-[14px] py-2 border border-brand-rule-grey rounded-md ml-0.5 text-black" }, value)) : null;
        }),
        variantAttributes
            .filter((attributeKey) => attributeKey === 'size')
            .map((attributeKey) => {
            const value = variantValues[attributeKey] ?? null;
            return value != null ? (React.createElement("div", { key: `${attributeKey}-container`, className: "text-xs leading-none font-gotham px-[14px] py-2 border border-brand-rule-grey rounded-md ml-0.5 text-black" },
                React.createElement("p", null, value))) : null;
        })));
};
